import { Skeleton } from '@fox/atoms';
import { useState } from 'react';
import { BPointClientAPI, PaymentAddComponentProps } from '../../../contracts';
import { CardForm } from '../../card-helpers';
import { BPointSettings, useBPointClientScripts } from '../../shared';

declare global {
	interface Window {
		BPOINT: BPointClientAPI;
	}
}

export function BPointAddCreditCard({ onSuccess, settings, completeIntent, intentData, onCancel, showSave }: PaymentAddComponentProps) {
	const ready = useBPointClientScripts(settings as BPointSettings); // This is required don't delete it
	const [error, setError] = useState<string | undefined>(undefined);
	const submit = submitData =>
		new Promise(resolve => {
			window.BPOINT.token.authkey.attachPaymentMethod(
				intentData.key,
				{
					card: {
						name: submitData.cardHolder,
						expiry: { month: submitData.expires.month, year: submitData.expires.year.slice(-2) },
						number: submitData.cardNumber
					}
				},
				async (status, data) => {
					console.log('setup complete', status, data);
					if (status === 'error') {
						setError('Failed to add payment method');
						return;
					}
					const result = await completeIntent(intentData.key, JSON.stringify(data.card));

					if (!result) {
						setError('Failed to create the new payment method');
						return;
					}
					onSuccess(result);
					resolve(result);
				}
			);
		});
	if (!ready) return <Skeleton />;

	return <CardForm submitFunc={submit} onCancel={onCancel} showSave={showSave} />;
}
